import styled from '@emotion/styled';

const Player = styled.div`
  width: 100%;
  height: 200px;
`;
export function Sidebar() {
  return <Player />;
}
